import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a916bd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "mt-4 flex-1" }
const _hoisted_3 = { class: "md:flex" }
const _hoisted_4 = { class: "flex-1 text-left" }
const _hoisted_5 = {
  "ion-text": "",
  class: "mt-0 mb-0",
  color: "primary"
}
const _hoisted_6 = { class: "mb-0 flex items-center" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-black" }
const _hoisted_9 = {
  key: 0,
  class: "text-black mt-1"
}
const _hoisted_10 = { class: "mt-2 mb-0 flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row justify-between items-center"
}
const _hoisted_12 = { class: "text-lg my-4" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "md:justify-between m-4 mt-4"
}
const _hoisted_16 = { class: "flex items-end flex-wrap gap-y-4 gap-x-2" }
const _hoisted_17 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_18 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "downloadPart my-4" }
const _hoisted_21 = { class: "text-left mt-2 sm:mb-0" }

import { generateBaShareLink } from "@/api/helper/api-helpers";
import AButton from "@/components/Base/AButton";
import AImage from "@/components/Base/AImage.vue";
import DateChange from "@/components/Base/DateChange.vue";
import PdfChip from "@/components/Pdf/Components/PdfChip.vue";
import DownloadSurveyButton from '@/components/v2/General/DownloadSurveyButton.vue';
import { useBestandsaufnahmens } from "@/composables/Bestandsaufnahme/useBestandsaufnahmens";
import useDateChangeUtils from "@/composables/Bestandsaufnahme/useDateChangeUtils";
import usePersonChangeUtils from "@/composables/Bestandsaufnahme/usePersonChangeUtils";
import { AppPlatform } from "@/composables/useAppInfo";
import useScreenSize from "@/composables/useScreenSize";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import Bestandsaufnahme from "@/models/ba/Bestandsaufnahme";
import {
  HzbaStatus,
  HzbaStatusCode,
  translatedHzbaStatus,
} from "@/models/ba/interfaces/IBestandsaufnahme";
import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import Immobilie from "@/models/immobilie.model";
import User from "@/models/user";
import { getPhotoUrl } from "@/utilities/get-media-url";
import { openBaseModal } from "@/modals/modal-helper";
import { Monitoring } from "@/utilities/monitoring";
import { Clipboard } from "@capacitor/clipboard";
import { Share } from "@capacitor/share";
import {
  IonButton,
  IonCard,
  IonIcon,
  IonLabel,
  toastController
} from "@ionic/vue";
import {
  addCircle,
  alertCircleOutline,
  archiveOutline,
  arrowDownCircle,
  arrowDownCircleOutline,
  calendarClearOutline,
  calendarOutline,
  checkmarkCircleOutline,
  checkmarkDoneCircleOutline,
  clipboardOutline,
  documentTextOutline,
  ellipseOutline,
  locationOutline,
  openOutline,
  playCircleOutline,
  shareSocialOutline,
  syncOutline,
  timeOutline
} from "ionicons/icons";
import moment from "moment";
import { ComputedRef, PropType, computed, ref, toRef, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import ProfileIcon from "../Base/ProfileIcon.vue";
import HzbaButton from "./Base/HzbaButton.vue";
import { SelectModeState } from "@/types/app/survey-types";


export default /*#__PURE__*/_defineComponent({
  __name: 'HzbaCard',
  props: {
  ba: {
    type: Object as PropType<Bestandsaufnahme>,
    required: true,
  },
  property: {
    type: Object as PropType<Immobilie>,
    required: false,
    default: null,
  },
  uiMode: {
    type: String,
    default: "normal",
  },
  withAddButton: {
    type: Boolean,
    default: false,
  },
  enableSelectMode: {
    type: Boolean,
    default: false,
  }
},
  emits: ["create-survey"],
  setup(__props) {

const props = __props;

const toast = ref<any>(null);
const isDownloading = ref(false);
const isCardSelected = ref(false);





const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();
  return currentUser ? currentUser.organisationPrefix : "";
});

const store = useStore();
const { t, locale } = useI18n({ useScope: "global" });
const { user, canUpdateBegehungsDate, canUpdateSichtungsDate, isImmobilienverwalter } = useUser();
const router = useRouter();
const {
  isPerformingDatabaseUpdate,
  changedBegehungsdate,
  changedSichtungsdate,
  saveBegehungsDate,
  saveSichtungsDate
} = useDateChangeUtils(toRef(props, 'ba'));

const { isMaxSmall } = useScreenSize();

const { openChangeStatusAlert, removeDownloadedBa } = useBestandsaufnahmens();
const { openChangePersonAlert } = usePersonChangeUtils();

const featureFlags = computed(() => user.value?.organisation?.featureFlags);

const isMobile = computed(() => {
  return store.getters["app/isMobile"];
});

const statusIconState = computed(() => {
  switch (props.ba.status) {
    case HzbaStatusCode.ANGELEGT: return ellipseOutline;
    case HzbaStatusCode.GEPLANT: return timeOutline;
    case HzbaStatusCode.IN_DURCHFUEHRUNG: return playCircleOutline;
    case HzbaStatusCode.ABGESCHLOSSEN: return checkmarkCircleOutline;
    case HzbaStatusCode.FREIGEGEBEN: return checkmarkDoneCircleOutline;
    case HzbaStatusCode.ARCHIVIERT: return archiveOutline;
    default: return alertCircleOutline;
  }
});

const immobilie = computed(() => {
  return props.property || Immobilie.getters('getPropOrFallbackProp')(props.ba.immobilie);
});

const gutachter = computed(() => {
  return props.ba.gutachter;
});

const persistedBestandsaufnahmes = computed(() => BestandsaufnahmeModel.getters("persistedBestandsaufnahmes"));

const alreadyInIndexDB = computed(() => {
  if (persistedBestandsaufnahmes.value?.some((item: any) => item.id === props.ba.id)) {
    return true;
  } else {
    return false;
  }
});

const malusColors = computed(() => {
  return store.getters["app/malusColors"];
});

const appPlatform = computed(() => store.state.app.appPlatform);

const openBericht = (e: any, pdf: any) => {
  e.stopImmediatePropagation();
  openBaseModal("pdf.view", { pdf: pdf });
};

const openMaengel = (e: any) => {
  e.stopImmediatePropagation();
  openBaseModal("maengel.uebersicht", { ba: props.ba });
};

const relevantMaengellist = computed(() => {
  if (props.ba && Array.isArray(props.ba.mangellists)) {
    return props.ba.mangellists.filter((el: any) => el.eingabeRelevant);
  }
  return [];
});

const geolocation = computed(() => {
  if (props.ba.geolocationLat && props.ba.geolocationLon) {
    return `${props.ba.geolocationLat.toFixed(4)}, ${props.ba.geolocationLon.toFixed(4)}`;
  } else if (immobilie.value && immobilie.value.geolocationLat && immobilie.value.geolocationLon) {
    return `${immobilie.value.geolocationLat.toFixed(4)}, ${immobilie.value.geolocationLon.toFixed(4)}`;
  } else {
    return null;
  }
});

const openMaengelInImmobilie = (e: any) => {
  e.stopImmediatePropagation();
  openBaseModal("maengel.immobilie.uebersicht", { ba: props.ba });
};

const recommendedBericht = (ba: any) => {
  if (ba.berichts && ba.berichts.length > 0) {
    const bericht = ba.berichts.find((el: any) =>
      el.kennzeichen.endsWith("-de")
    );
    return bericht && bericht.data;
  }
  return ba.bericht;
};

const recommendedMangelliste = (ba: any) => {
  if (ba.mangellists && ba.mangellists.length > 0) {
    // Monitoring.consoleOnly('ba.mangellists: ', ba.mangellists[0].mangelvorlage.kategorie);
  }
  return ba.mangellists;
};

const goToBa = async (e: any) => {
  e.stopImmediatePropagation();
  if (!isImmobilienverwalter()) {
    await router.push("/ba/" + props.ba.id);
  }
};

const handleStatusChange = (e: any) => {
  if (featureFlags?.value.survey?.changeStatus) {
    e.stopImmediatePropagation();
    openChangeStatusAlert(props.ba, t);
  }
};

const handlePersonChange = () => {
  if (featureFlags?.value.survey?.changePerson) {
    if (user.value?.organisation?.id) {
      openChangePersonAlert(props.ba);
    } else {
      Monitoring.error("Cannot change person field. User has no organisation id");
    }
  }
};

const downloadBestandsaufnahme = async () => {
  isDownloading.value = true;

  try {
    await BestandsaufnahmeModel.dispatch("fetchMoverSurveyById", { surveyId: props.ba.id, saveToStore: true });
    isDownloading.value = false;
  } catch (err: any) {
    Monitoring.consoleOnly(err);
    isDownloading.value = false;
  }
};

const removeFromIndexDB = async () => {
  removeDownloadedBa(props.ba);
};

const handleBaShare = async () => {
  const url = generateBaShareLink(props.ba.id.toString());
  if (appPlatform.value === AppPlatform.desktop) {
    await Clipboard.write({
      string: url
    });

    const toast = await toastController.create({
      message: t('hzba.toast.urlCopied'),
      duration: 3000,
      cssClass: 'copyUrlToast'
    });

    await toast.present();
  } else {
    await Share.share({
      title: t('hzba.shareBa.title'),
      text: t('hzba.shareBa.text'),
      url: url,
    });
  }
};

const openToast = async (event: MouseEvent) => {
  if (!event.relatedTarget || (event.relatedTarget as HTMLElement).tagName.toLowerCase() === 'ion-icon') {
    // https://stackoverflow.com/questions/37403733/jquery-onclick-triggers-mouseover-on-touch-device
    // triggered by click and not by hover
    return;
  }
  toast.value = await toastController.create({
    message: t("hzba.toast.downloadedInfo"),
    duration: 500,
    position: 'bottom',
    cssClass: 'downloadInfoToast'
  });
  await toast.value.present();
};

const closeToast = () => {
  toast.value?.dismiss();
};

const toggleSelection = () => {
  isCardSelected.value = !isCardSelected.value;
  BestandsaufnahmeModel.dispatch("toggleSurveyCardSelection", props.ba.id);
};

watch(alreadyInIndexDB, () => {
  if (toast.value) {
    toast.value?.dismiss();
  }
});

watch(() => store.state.entities.bestandsaufnahmes.selectModeSurveyCards, (value: SelectModeState) => {
  if (props.enableSelectMode) {
    if (value === SelectModeState.ALL) {
      isCardSelected.value = true;
    } else if (value === SelectModeState.NONE) {
      isCardSelected.value = false;
    }
  }
});


return (_ctx: any,_cache: any) => {
  return (__props.ba && immobilie.value)
    ? (_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        class: _normalizeClass(["hzbaCard m-0 rounded-sm acon-card-shadow", [
      `${!_unref(isImmobilienverwalter)() ? 'cursor-pointer' : ''}`,
      __props.withAddButton ? 'flex flex-row pr-4' : 'px-4 flex flex-col justify-between',
      isCardSelected.value ? 'backgroundWhenCardSelected' : 'bg-white'
    ]]),
        onClick: _cache[18] || (_cache[18] = ($event: any) => (goToBa($event)))
      }, {
        default: _withCtx(() => [
          (__props.enableSelectMode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "card-select-overlay",
                role: "checkbox",
                onClick: _withModifiers(toggleSelection, ["stop"])
              }, [
                _createVNode(_unref(IonIcon), {
                  icon: isCardSelected.value ? _unref(checkmarkCircleOutline) : _unref(ellipseOutline),
                  size: "large",
                  class: "checkmark-icon"
                }, null, 8, ["icon"])
              ], 8, _hoisted_1))
            : _createCommentVNode("", true),
          (__props.withAddButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "h-auto pl-2 pr-2 mr-1 shadow-lg rounded-lg flex",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('create-survey')), ["stop"]))
              }, [
                _createVNode(_unref(IonIcon), {
                  slot: "icon-only",
                  class: "h-12 w-12 my-auto",
                  icon: _unref(addCircle)
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({ 'ml-2': __props.withAddButton })
          }, [
            _createElementVNode("div", null, [
              (__props.uiMode === 'normal')
                ? (_openBlock(), _createBlock(AImage, {
                    key: 0,
                    "image-class": 'w-full h-44 object-cover md:block',
                    src: immobilie.value && _unref(getPhotoUrl)(immobilie.value.vorschaubild, { thumbnail: true })
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, _toDisplayString(__props.ba.getName && __props.ba.getName()), 1),
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(immobilie.value && immobilie.value.externeObjektNr) + " (" + _toDisplayString(_unref(moment)(__props.ba.begehungsdatum).format("YYYY")) + ") ", 1),
                    _createElementVNode("p", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(locationOutline),
                          class: "mr-2 mt-0.5"
                        }, null, 8, ["icon"]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(immobilie.value && (immobilie.value.strasse ? immobilie.value.strasse + "," : "")) + " " + _toDisplayString(immobilie.value && immobilie.value.plz) + " " + _toDisplayString(immobilie.value && immobilie.value.stadt), 1),
                          (geolocation.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " [" + _toDisplayString(geolocation.value) + "] ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(DateChange, {
                        modelValue: _unref(changedBegehungsdate),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(changedBegehungsdate) ? (changedBegehungsdate).value = $event : null)),
                        format: "icon",
                        title: _ctx.$t(`${organisationPrefix.value}hzba.datum.begehung`),
                        loading: _unref(isPerformingDatabaseUpdate),
                        "date-icon": _unref(calendarClearOutline),
                        readonly: !_unref(canUpdateBegehungsDate),
                        onChanged: _unref(saveBegehungsDate)
                      }, null, 8, ["modelValue", "title", "loading", "date-icon", "readonly", "onChanged"]),
                      _createVNode(DateChange, {
                        modelValue: _unref(changedSichtungsdate),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(changedSichtungsdate) ? (changedSichtungsdate).value = $event : null)),
                        format: "icon",
                        title: _ctx.$t(`${organisationPrefix.value}hzba.datum.sichtung`),
                        loading: _unref(isPerformingDatabaseUpdate),
                        "date-icon": _unref(calendarOutline),
                        readonly: !_unref(canUpdateSichtungsDate),
                        onChanged: _unref(saveSichtungsDate)
                      }, null, 8, ["modelValue", "title", "loading", "date-icon", "readonly", "onChanged"]),
                      _createElementVNode("p", _hoisted_10, [
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(syncOutline),
                          class: "mr-2",
                          title: _ctx.$t('hzba.zuletztAktualisiertAm')
                        }, null, 8, ["icon", "title"]),
                        _createTextVNode(" " + _toDisplayString(_unref(moment)(__props.ba.updatedAt).format("DD.MM.YYYY")) + " ", 1),
                        _createVNode(_unref(IonIcon), {
                          icon: _unref(timeOutline),
                          class: "ml-3 mr-1"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_unref(moment)(__props.ba.updatedAt).format("HH:mm")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (__props.uiMode === 'compact')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(IonButton), {
                      class: "open-survey",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (goToBa($event)), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        (!_unref(isMaxSmall))
                          ? (_openBlock(), _createBlock(_unref(IonLabel), {
                              key: 0,
                              class: "px-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("immobilie.toOpen")), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_unref(IonIcon), {
                              key: 1,
                              class: "w-5 h-5",
                              icon: _unref(openOutline)
                            }, null, 8, ["icon"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-row items-center justify-end mini", _unref(isMaxSmall) ? 'gap-2' : 'gap-4'])
                  }, [
                    (recommendedBericht(__props.ba))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          "btn-secondary": true,
                          class: "h-8 text-base cursor-pointer",
                          shape: "round",
                          "data-cy": "button-berichtAnzeigen",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {$event.stopPropagation(); openBericht($event, recommendedBericht(__props.ba))})
                        }, [
                          _createVNode(_unref(IonIcon), {
                            size: "large",
                            icon: _unref(documentTextOutline)
                          }, null, 8, ["icon"])
                        ]))
                      : (__props.ba?.hasPdfSupport())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "cursor-pointer",
                            type: "button",
                            fill: "solid",
                            shape: "round",
                            "data-cy": "btn-pdf-preview",
                            "btn-primary": true,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {$event.stopPropagation(); _ctx.$router.push(`/ba/${__props.ba?.id}/pdf-preview`)})
                          }, [
                            _createVNode(_unref(IonIcon), {
                              size: "large",
                              icon: _unref(clipboardOutline)
                            }, null, 8, ["icon"])
                          ]))
                        : _createCommentVNode("", true),
                    (featureFlags.value?.survey?.changeStatus)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "flex cursor-pointer",
                          title: _ctx.$t('immobilie.updateStatus'),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {$event.stopPropagation(); handleStatusChange($event)})
                        }, [
                          _createVNode(_unref(IonIcon), {
                            size: "large",
                            icon: statusIconState.value
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_13))
                      : _createCommentVNode("", true),
                    (featureFlags.value?.survey?.changePerson)
                      ? (_openBlock(), _createBlock(ProfileIcon, {
                          key: 3,
                          user: gutachter.value,
                          onChange: handlePersonChange
                        }, null, 8, ["user"]))
                      : _createCommentVNode("", true),
                    (alreadyInIndexDB.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: "flex cursor-pointer",
                          onMouseover: _cache[7] || (_cache[7] = ($event: any) => (openToast($event))),
                          onMouseout: _cache[8] || (_cache[8] = ($event: any) => (closeToast())),
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {closeToast(); removeFromIndexDB();}, ["stop"]))
                        }, [
                          _createVNode(_unref(IonIcon), {
                            size: "large",
                            icon: _unref(arrowDownCircle)
                          }, null, 8, ["icon"])
                        ], 32))
                      : _createCommentVNode("", true),
                    (featureFlags.value.downloadSurvey && !alreadyInIndexDB.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          fill: "clear",
                          class: "flex cursor-pointer",
                          onClick: _withModifiers(downloadBestandsaufnahme, ["stop"])
                        }, [
                          _createVNode(_unref(IonIcon), {
                            size: "large",
                            icon: _unref(arrowDownCircleOutline)
                          }, null, 8, ["icon"])
                        ], 8, _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "flex cursor-pointer",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => ($event.stopPropagation(), handleBaShare()))
                    }, [
                      _createVNode(_unref(IonIcon), {
                        size: "large",
                        icon: _unref(shareSocialOutline)
                      }, null, 8, ["icon"])
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (__props.uiMode === 'normal')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (__props.ba.malus)
                      ? (_openBlock(), _createBlock(PdfChip, {
                          key: 0,
                          class: "mr-2",
                          value: __props.ba.malus,
                          color: malusColors.value[__props.ba.malusColor],
                          big: true
                        }, null, 8, ["value", "color"]))
                      : _createCommentVNode("", true),
                    _createVNode(HzbaButton, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (handleStatusChange($event)))
                    }, {
                      default: _withCtx(() => [
                        (!_unref(HzbaStatus)[__props.ba.status])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Status unbekannt "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(translatedHzbaStatus)(__props.ba.status, _unref(t))), 1)),
                        _createVNode(_unref(IonIcon), {
                          size: "small",
                          icon: statusIconState.value
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    (alreadyInIndexDB.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "alreadyInIndexDB",
                          onMouseover: _cache[12] || (_cache[12] = ($event: any) => (openToast($event))),
                          onMouseout: _cache[13] || (_cache[13] = ($event: any) => (closeToast())),
                          onClick: _cache[14] || (_cache[14] = ($event: any) => {$event.stopPropagation(); closeToast(); removeFromIndexDB()})
                        }, [
                          _createVNode(_unref(IonIcon), { icon: _unref(arrowDownCircle) }, null, 8, ["icon"])
                        ], 32))
                      : _createCommentVNode("", true),
                    (featureFlags.value?.survey?.changePerson)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (isMobile.value)
                            ? (_openBlock(), _createBlock(ProfileIcon, {
                                key: 0,
                                user: gutachter.value,
                                onChange: handlePersonChange
                              }, null, 8, ["user"]))
                            : (_openBlock(), _createBlock(HzbaButton, {
                                key: 1,
                                onClick: handlePersonChange
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(gutachter.value ? gutachter.value.username : _ctx.$t('hzba.notAssigned')), 1)
                                ]),
                                _: 1
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (featureFlags.value.downloadSurvey && !alreadyInIndexDB.value)
                      ? (_openBlock(), _createBlock(DownloadSurveyButton, {
                          key: 0,
                          "is-downloading": isDownloading.value,
                          onOnClick: downloadBestandsaufnahme
                        }, null, 8, ["is-downloading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (recommendedBericht(__props.ba))
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 0,
                          "btn-secondary": true,
                          class: "w-full p-2 h-10 text-base",
                          shape: "round",
                          "data-cy": "button-berichtAnzeigen",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (openBericht($event, recommendedBericht(__props.ba))))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("hzba.buttons.berichtAnzeigen")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (relevantMaengellist.value && relevantMaengellist.value.length > 0)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 1,
                          "btn-secondary": true,
                          class: "w-full mb-1 text-base",
                          shape: "round",
                          "data-cy": "button-mangellisteAnzeigen",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (openMaengelInImmobilie($event)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("immobilie.buttons.mangellisteAnzeigen")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.uiMode === 'normal')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "flex cursor-pointer p-4 justify-end",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($event.stopPropagation(), handleBaShare()))
                }, [
                  _createVNode(_unref(IonIcon), {
                    size: "small",
                    icon: _unref(shareSocialOutline)
                  }, null, 8, ["icon"])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})